import { FC } from 'react';
import { Typography, Container, Paper, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { StyledDocument } from '../molecules/StyledDocument';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(5, 2, 10),
      backgroundColor: '#f2f3fb',
      [theme.breakpoints.up('tablet')]: {
        padding: theme.spacing(5, 5, 10),
      },
    },
    inner: {},
    pageTitle: {
      textAlign: 'center',
      '&::after': {
        background:
          'transparent linear-gradient(90deg, #30CFD0 0%, #002477 100%) 0% 0% no-repeat padding-box',
        content: '""',
        display: 'block',
        height: '6px',
        margin: theme.spacing(3, 'auto', 5),
        width: '160px',
      },
    },
    paper: {
      maxWidth: '960px',
      margin: '0 auto',
      padding: theme.spacing(5, 5),
      [theme.breakpoints.up('tablet')]: {
        padding: theme.spacing(10, 10),
      },
      boxShadow: '0px 16px 32px #00000014',
      borderRadius: '8px',
      transition: 'initial',
    },
  }),
);

export interface TermsProps {
  className?: string;
  pageTitle?: string | JSX.Element | JSX.Element[];
  children?: string | JSX.Element | JSX.Element[];
}

export const Terms: FC<TermsProps> = ({ pageTitle, children, className }) => {
  const classes = useStyles();
  return (
    <Container
      disableGutters
      maxWidth={false}
      className={`${classes.root} ${className ?? ''}`}
    >
      <StyledDocument>
        {pageTitle && (
          <Typography variant="h1" className={classes.pageTitle}>
            {pageTitle}
          </Typography>
        )}
        <Paper className={classes.paper}>{children}</Paper>
      </StyledDocument>
    </Container>
  );
};
